export interface BuildingDocumentSelectionIdentity {
    readonly userId: string;
    readonly organisationId: string;
    readonly buildingId: string;
}

export interface BuildingDocumentSelectionHandoff extends BuildingDocumentSelectionIdentity {
    readonly kind: 'building-document-selection';
    readonly version: 1;
    readonly documentIds: readonly string[];
}

export const BUILDING_DOCUMENT_SELECTION_STATE_KEY =
    'buildingDocumentSelection';

export function createBuildingDocumentSelectionHandoff(
    identity: BuildingDocumentSelectionIdentity,
    documentIds: readonly string[]
): BuildingDocumentSelectionHandoff {
    return {
        ...identity,
        kind: 'building-document-selection',
        version: 1,
        documentIds: [...new Set(documentIds)],
    };
}

export function parseBuildingDocumentSelectionHandoff(
    value: unknown,
    identity: BuildingDocumentSelectionIdentity
): BuildingDocumentSelectionHandoff | null {
    if (typeof value !== 'object' || value === null) return null;
    const candidate = value as Record<string, unknown>;
    const ids = candidate['documentIds'];
    if (
        candidate['kind'] !== 'building-document-selection' ||
        candidate['version'] !== 1 ||
        candidate['userId'] !== identity.userId ||
        candidate['organisationId'] !== identity.organisationId ||
        candidate['buildingId'] !== identity.buildingId ||
        !Array.isArray(ids) ||
        ids.length === 0 ||
        !ids.every(
            (id: unknown): id is string =>
                typeof id === 'string' && id.length > 0 && id.trim() === id
        ) ||
        new Set(ids).size !== ids.length
    )
        return null;
    return createBuildingDocumentSelectionHandoff(identity, ids);
}
